import 'htmx.org';
import { initAuthorPage } from './modules/author-page';
import { initErrorPage } from './modules/error-page';
import { initCookieConsent } from './modules/cookie-consent';
import { initExpertPanels } from './modules/expert-panel';
import { initArticleShare } from './modules/article-share';
import { initFcMediaEmbedUrls } from './modules/fc-media-embed';
import { initArticleLinks } from './modules/article-links';
import { initFcMediaStartOverlaysForDamVideoBlocks } from './modules/fc-media-start-overlay';
import { initFcVideoJs } from './modules/fc-video-player';
import { initFcYoutubeEmbeds } from './modules/fc-youtube';
import { initVideoShowcasePlaylist } from './modules/fc-video-showcase';
import { initVideoShowcaseDurations } from './modules/fc-video-showcase-duration';
import { initVideoShowcaseYoutubeTitles } from './modules/fc-video-showcase-yt-titles';
import { initArticleList } from './modules/article-list';
import { initNav } from './components/nav';
import { initHeaderSearch } from './modules/header-search';
import { initCustomSelects } from './modules/custom-select.ts';
import { initFormGenerators } from './modules/form';
export {};

interface FCGlobal {
  initialized: boolean;
}

declare global {
  interface Window {
    FC?: FCGlobal;
  }
}

function init(): void {
  window.FC = { initialized: true };
  initAuthorPage();
  initErrorPage();
  initCookieConsent();
  initExpertPanels();
  initArticleShare();
  initArticleLinks();
  initNav();
  initHeaderSearch();
  initFcMediaEmbedUrls();
  initFcVideoJs();
  initFcMediaStartOverlaysForDamVideoBlocks();
  initFcYoutubeEmbeds();
  initArticleList();
  initVideoShowcasePlaylist();
  initCustomSelects();
  initFormGenerators();
  void initVideoShowcaseDurations();
  void initVideoShowcaseYoutubeTitles();
  initCookieConsent();
}

document.addEventListener('DOMContentLoaded', init);
